import MaterialTable from "material-table";
import React, { useEffect, useState, useRef } from "react";
import {
  Convention,
  GeneralStyle,
  RightSection,
} from "./DetailReportsList.styled";
import { Row, Col } from "react-bootstrap";
import Snackbar from "@material-ui/core/Snackbar";
import MuiAlert from "@material-ui/lab/Alert";
import { ClickAwayListener, Tooltip, withStyles } from "@material-ui/core";
import InfoIcon from "@material-ui/icons/Info";
import ExportExcelFile from "../../components/ReportSurveyBlock/ExportExcelFile/ExportExcelFile";
import AssessmentIcon from "@material-ui/icons/Assessment";
import IconButton from "@material-ui/core/IconButton";
import moment from "moment";
import ViewControlMenu from "../ViewControlMenu/ViewControlMenu";
import DownloadLink from "../DownloadLink/DownloadLink";
import TablePagination from "@material-ui/core/TablePagination";
import ModalLoader from "../ModalLoader/ModalLoader";
import { useLazyQuery } from "@apollo/client";
import { ALL_SURVEYS_DETAIL_REPORTS } from "../../GraphQL/Queries";
import SearchComponent from "../../components/SearchComponent/SearchComponent";
import TableActionComponent from "../TableActionComponent/TableActionComponent";
import { ROLES } from "../../util/RolesConstants";
import NoRecord from "../NoRecord/NoRecord";
import PropTypes from "prop-types";
import { theme as themeConfig } from "../../themes/themes";

const HtmlTooltip = withStyles((theme) => ({
  tooltip: {
    backgroundColor: themeConfig.neutral.gray[2500],
    color: "white",
    padding: "1em 1em 1em 0",
    border: "1px solid #dadde9",
  },
}))(Tooltip);

const Alert = (props) => {
  return <MuiAlert elevation={6} variant="filled" {...props} />;
};

const DetailReportsList = ({
  dataExport,
  nameFile,
  user,
  handleClose,
  open,
  handleDownloadRemaining,
  showUsersAsnwered,
  setShowUsersAsnwered,
  getInfoUsersAnswered,
  goToReport,
  titleOfTable,
}) => {
  const [showLoader, setShowLoader] = useState(false);
  const [showCards, setShowCards] = useState(true);
  const [detailReportsList, setDetailReportsList] = useState([]);
  const [searchText, setSearchText] = useState("");
  const rSearch = useRef();
  const [allPages, setAllPages] = useState(0);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const rowsPerPageOptions = [5, 10, 20];
  const [startCursor, setStartCursor] = useState("");
  const [endCursor, setEndCursor] = useState("");

  const [runQuerySurveyList, { error }] = useLazyQuery(
    ALL_SURVEYS_DETAIL_REPORTS,
    {
      fetchPolicy: "network-only",
      onCompleted: (data) => {
        handleAssignData(data);
      },
      onError: (error) => {
        setShowLoader(false);
      },
    }
  );

  useEffect(() => {
    if(user?.roleId){
      setShowLoader(true);
      runQuerySurveyList({
        variables: { searchBy: searchText, first: rowsPerPage },
      });
      setPage(0);
    }
  }, [searchText, user?.roleId]);

  const handleAssignData = (data) => {
    if (data?.allSurveyReport?.nodes) {
      const reports = data.allSurveyReport.nodes.map((e) => {
        return {
          ...e,
          country: e?.surveyLocationInfo?.countryName,
          city: e?.surveyLocationInfo?.cityName,
        };
      });
      setDetailReportsList(reports);
      if (data.allSurveyReport.pageInfo.hasNextPage === true) {
        setEndCursor(data.allSurveyReport.pageInfo.endCursor);
      }
      if (data.allSurveyReport.pageInfo.hasPreviousPage === true) {
        setStartCursor(data.allSurveyReport.pageInfo.startCursor);
      }
      setAllPages(data.allSurveyReport?.totalCount);
    }
    setShowLoader(false);
  };

  const getDataBySearch = () => {
    setSearchText(rSearch?.current?.value);
  };

  const applySearchOnBreak = () => {
    let timer;
    return function () {
      clearTimeout(timer);
      timer = setTimeout(() => {
        getDataBySearch();
      }, 500);
    };
  };

  const handleSearch = applySearchOnBreak();

  const handleChangeRowsPerDetailReport = (event) => {
    setRowsPerPage(event.target.value ? parseInt(event.target.value) : 5);
    setPage(0);
    runQuerySurveyList({
      variables: {
        first: event.target.value ? parseInt(event.target.value) : 5,
        searchBy: searchText || "",
      },
    });
  };

  const handleChangePageDetailReport = (event, newPage) => {
    if (newPage > page) {
      setShowLoader(true);
      runQuerySurveyList({
        variables: {
          first: rowsPerPage,
          after: endCursor,
          searchBy: searchText || "",
        },
      });
    } else if (newPage < page) {
      setShowLoader(true);
      runQuerySurveyList({
        variables: {
          last: rowsPerPage,
          before: startCursor,
          searchBy: searchText || "",
        },
      });
    }
    setPage(newPage);
  };

  const getSurveyState = (id) => {
    if (id) {
      if (id === 3) return "Disable";
      else if (id == 1) return "Pending Activation";
    }
    return "Active";
  };

  const getSurveyStateColor = (id) => {
    if (id) {
      if (id === 2) return "rgba(4, 180, 105, 1)";
      else return "rgba(191, 191, 191, 1)";
    }
  };

  return (
    <GeneralStyle>
      {dataExport && (
        <ExportExcelFile
          data={dataExport}
          nameFile={nameFile}
        ></ExportExcelFile>
      )}
      {showLoader && <ModalLoader />}
      {error && (
        <Row>
          <Col md="12" className="d-flex justify-content-center mt-5">
            <h1>Error :( </h1>
          </Col>
        </Row>
      )}
      {user?.roleId ? (
        <div>
          <Snackbar open={open} autoHideDuration={1200} onClose={handleClose}>
            {alert ? (
              <Alert onClose={handleClose} severity="success">
                The link was generated correctly
              </Alert>
            ) : (
              <Alert onClose={handleClose} severity="error">
                The link was not generated, please try again
              </Alert>
            )}
          </Snackbar>
          <div>
            <RightSection>
              <SearchComponent
                handleSearch={handleSearch}
                rSearch={rSearch}
                setSearchText={setSearchText}
              />
              <TableActionComponent
                showCards={showCards}
                setShowCards={setShowCards}
              />
            </RightSection>
          </div>
          {!showCards && !showLoader && (
            <MaterialTable
              style={{ boxShadow: "none", margin: "10px" }}
              title={titleOfTable}
              columns={[
                {
                  title: "Survey Id",
                  field: "idSurvey",
                  type: "string",
                  cellStyle: {
                    padding: "0px 16px",
                  },
                },
                {
                  title: "Name",
                  field: "surveyName",
                  type: "string",
                  cellStyle: {
                    padding: "0px 16px",
                  },
                },
                {
                  title: "Assigned Users",
                  field: "assignedUsers",
                  type: "numeric",
                  cellStyle: {
                    padding: "0px 16px",
                  },
                },
                {
                  title: "Have Answered",
                  field: "answeredSurveys",
                  type: "numeric",
                  cellStyle: {
                    padding: "0px 16px",
                  },
                },
                {
                  title: "Haven't Answered",
                  field: "remainingSurveys",
                  type: "numeric",
                  cellStyle: {
                    padding: "0px 16px",
                  },
                  render: (rowData) => (
                    <DownloadLink
                      linkName={rowData.remainingSurveys}
                      object={rowData}
                      fn={handleDownloadRemaining}
                    />
                  ),
                },
                {
                  title: "Activation Date",
                  field: "activateSurveyDate",
                  type: "string",
                  cellStyle: {
                    padding: "0px 16px",
                  },
                  render: (rowData) => {
                    return moment(
                      rowData.activateSurveyDate,
                      "YYYY-MM-DD hh:mm a"
                    ).format("YYYY-MM-DD hh:mm a");
                  },
                },
                {
                  title: "Created by",
                  field: "createUser",
                  type: "string",
                  cellStyle: {
                    maxWidth: "170px",
                    padding: "0px 16px",
                  },
                  render: (rowData) => {
                    return (
                      <Row>
                        <Col
                          md="12"
                          style={{
                            overflowX: "hidden",
                            whiteSpace: "nowrap",
                            textOverflow: "ellipsis",
                          }}
                        >
                          {rowData.createUser}
                        </Col>
                      </Row>
                    );
                  },
                },
                {
                  title: "Country",
                  field: "country",
                  type: "string",
                  cellStyle: {
                    padding: "0px 16px",
                  },
                },
                {
                  title: "City",
                  field: "city",
                  type: "string",
                  cellStyle: {
                    padding: "0px 16px",
                  },
                },
                {
                  title: "State",
                  field: "idSurveyState",
                  type: "string",
                  filtering: false,
                  cellStyle: {
                    padding: "0px 16px",
                  },
                  render: (rowData) => {
                    return (
                      <Tooltip title={getSurveyState(rowData?.idSurveyState)}>
                        <div
                          className="point"
                          style={{
                            background: getSurveyStateColor(
                              rowData?.idSurveyState
                            ),
                            height: "1em",
                            width: "1em",
                            borderRadius: "7px",
                          }}
                        ></div>
                      </Tooltip>
                    );
                  },
                },
                {
                  title: "Info",
                  field: "InfoAnswered",
                  filtering: false,
                  sorting: false,
                  cellStyle: {
                    padding: "0 0 0 16px",
                  },
                  headerStyle: {
                    padding: "0 0 0 16px",
                  },
                  render: (rowData) => {
                    return (
                      <ClickAwayListener
                          onClickAway={(e) => {
                            if (showUsersAsnwered === rowData.idSurvey) {
                              setShowUsersAsnwered(0);
                            }
                          }}
                        >
                          <HtmlTooltip
                            arrow
                            open={
                              showUsersAsnwered === rowData.idSurvey
                                ? true
                                : false
                            }
                            placement="right"
                            PopperProps={{
                              disablePortal: true,
                            }}
                            disableFocusListener
                            disableHoverListener
                            disableTouchListener
                            title={
                              <>
                                {!rowData.surveyDescription ? (
                                  <p
                                    style={{
                                      padding: "1em",
                                      margin: "0",
                                      listStyleType: "circle",
                                      lineHeight: "1.3",
                                      fontSize: "13px",
                                    }}
                                  >
                                    {" "}
                                    Loading...{" "}
                                  </p>
                                ) : (
                                  <ul
                                    style={{
                                      margin: "0",
                                      listStyleType: "circle",
                                      lineHeight: "1.3",
                                      fontSize: "13px",
                                    }}
                                  >
                                    <li
                                      style={{
                                        listStyleType: "disclosure-closed",
                                      }}
                                    >
                                      <b>Description:</b>{" "}
                                      {`${rowData.surveyDescription}`}
                                    </li>
                                  </ul>
                                )}
                              </>
                            }
                          >
                            <InfoIcon
                              style={{
                                color: "rgba(46, 46, 46, 1)",
                                cursor: "pointer",
                              }}
                              alt=""
                              onClick={() => {
                                getInfoUsersAnswered(rowData.idSurvey);
                              }}
                            />
                          </HtmlTooltip>
                        </ClickAwayListener>
                    );
                  },
                },
                {
                  title: "Go to Report",
                  field: "internal_action",
                  filtering: false,
                  sorting: false,
                  cellStyle: {
                    padding: "0px 16px",
                  },
                  render: (rowData) => {
                    return (
                      <Row>
                        <Col md="12">
                          <IconButton
                            variant="contained"
                            style={{ cursor: "pointer" }}
                            onClick={() => {
                              goToReport(rowData);
                            }}
                          >
                            <AssessmentIcon
                              style={{
                                fontSize: "23px",
                                color: "rgba(46, 46, 46, 1)",
                              }}
                            />
                          </IconButton>
                        </Col>
                      </Row>
                    );
                  },
                },
              ]
                .map((item) => ({ ...item }))
                .filter((item) => {
                  return item.title !== "";
                })}
              data={detailReportsList}
              options={{
                maxBodyHeight: 450,
                paging: false,
                search: false,
                filtering: false,
                toolbar: false,
                headerStyle: {
                  zIndex: 1,
                  fontWeight: "bold",
                },
                cellStyle: {
                  padding: "5px 10px",
                },
              }}
            ></MaterialTable>
          )}
          {showCards && !showLoader && (
            <>
              <ViewControlMenu
                className="mt-5"
                identity={"detail-report-list"}
                title={titleOfTable}
                showCards={showCards}
                setShowCards={setShowCards}
                list={detailReportsList}
                handleSeeDetails={goToReport}
                handleDownload={handleDownloadRemaining}
                isAgent={false}
              />
              {detailReportsList?.length === 0 ? <NoRecord /> : null}
            </>
          )}
          <div style={{ display: "flex", width: "100%", margin: "10px" }}>
            {user && user.roleId !== ROLES.AGENT && (
              <Convention>
                <div
                  style={{
                    background: "rgba(191, 191, 191, 1)",
                    height: "1em",
                    width: "1em",
                    borderRadius: "7px",
                  }}
                ></div>
                <p>Disable</p>
                <div
                  style={{
                    background: "rgba(4, 180, 105, 1)",
                    height: "1em",
                    width: "1em",
                    borderRadius: "7px",
                  }}
                ></div>
                <p>Active</p>
              </Convention>
            )}
            {!showLoader && (
              <TablePagination
                component="div"
                style={{
                  display: "flex",
                  justifyContent: "flex-end",
                  width: "49%",
                }}
                count={allPages}
                page={page}
                onPageChange={handleChangePageDetailReport}
                rowsPerPage={rowsPerPage}
                rowsPerPageOptions={rowsPerPageOptions}
                onRowsPerPageChange={handleChangeRowsPerDetailReport}
              />
            )}
          </div>
        </div>
      ) : null}
    </GeneralStyle>
  );
};

DetailReportsList.propTypes = {
  dataExport: PropTypes.array,
  nameFile: PropTypes.string,
  user: PropTypes.object,
  handleClose: PropTypes.func,
  open: PropTypes.bool,
  handleDownloadRemaining: PropTypes.func,
  showUsersAsnwered: PropTypes.number,
  setShowUsersAsnwered: PropTypes.func,
  getInfoUsersAnswered: PropTypes.func,
  goToReport: PropTypes.func,
  titleOfTable: PropTypes.string,
};

export default DetailReportsList;
